import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import * as React from 'react';

export function SvgInfo() {
  return <InformationCircleIcon label="" testId="ads-refreshed-icon" />;
}
